import createMetadataAPIActions from '../../utils/api-metadata-actions';
import types from './types';

const options = {
  name: 'certifications',
  baseType: 'CERTIFICATIONS',
  apiEndpoint: 'certifications'
};

const actions = createMetadataAPIActions(options);

const clearCertifications = membershipId => ({
  type: types.CLEAR_CERTIFICATIONS,
  payload: { membershipId }
});

export default {
  ...actions,
  clearCertifications
};
